import DOMPurify from "dompurify";

export const getCookie = (name) => {
  const match = new RegExp(`(^| )${name}=([^;]+)`).exec(document.cookie);
  return (match && match[2]) || "";
};

export const cleanedComment = (comment) => {
  const sanitizedComment = DOMPurify.sanitize(comment);
  return sanitizedComment
    .replace(/\s{2,}/g, " ")
    .replace(/\n+/g, " ")
    .trim();
};
